import { render, staticRenderFns } from "./Form18CaseInformation.vue?vue&type=template&id=f0e17006&scoped=true"
import script from "./Form18CaseInformation.vue?vue&type=script&lang=ts"
export * from "./Form18CaseInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e17006",
  null
  
)

export default component.exports